import * as React from 'react';
import { useSelector } from 'react-redux';

import { ControlsContainer as Controls } from './Controls';
import { Features, IFeaturesApi } from './Features';
import { IInfrastructureFeaturesApi, InfrastructureFeatures } from './Infrastructure';
import { Polygons } from './Polygons';
import { Tags } from './Tags';
import { selectIsInfrastructureOnMapEnabled } from '../../../selectors';

export function MapLayers() {
  const featuresRef = React.useRef<IFeaturesApi>(null);
  const isInfrastructureEnabled = useSelector(selectIsInfrastructureOnMapEnabled);
  const infrastructureFeaturesRef = React.useRef<IInfrastructureFeaturesApi>(null);

  React.useEffect(() => {
    const featuresApi = featuresRef.current;
    const infrastructureFeaturesApi = infrastructureFeaturesRef.current;

    featuresApi?.init();
    infrastructureFeaturesApi?.init();

    return () => {
      infrastructureFeaturesApi?.destroy();
      featuresApi?.destroy();
    };
  }, []);

  return (
    <>
      <Tags />
      <Features ref={featuresRef} />
      {isInfrastructureEnabled && <InfrastructureFeatures ref={infrastructureFeaturesRef} />}
      <Controls />
      <Polygons />
    </>
  );
}
